import React from "react";
import jwtEncode from "jwt-encode";
import {UnoStoreHooks } from "@simulanisindia/ui";
import { applicationId, SSO_URL } from "../env";
import { useParams } from "react-router-dom";

const { useUnoSelector } = UnoStoreHooks;

const Login = () => {
  const { channelId: paramsChannelId } = useParams();
  const currentURL = window.location.href;
  const urlObject = new URL(currentURL);
  const configData = useUnoSelector((state) => state.config);
  let referrerUrlParam = urlObject.searchParams.get("referrer");
  const channelId = !paramsChannelId ? configData?.config?.channel?.uuid : paramsChannelId;

  if (!referrerUrlParam) {
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
      applicationId,
    };
    referrerUrlParam = jwtEncode(payload, "");
  }

  return (
    <div className="sso-parent">
      <iframe
        src={
          channelId
            ? `${SSO_URL}/gateway/web/${channelId}?referrer=${referrerUrlParam}`
            : `${SSO_URL}/gateway/web?referrer=${referrerUrlParam}`
        }
        title="SSO"
        style={{ width: "100%", height: "100vh" }}
      />
    </div>
  );
};

export default Login;
